export const campaignTableColumns = [
  { key: "name", value: "Name" },
  { key: "created", value: "Created" },
  { key: "lastUpadted", value: "Last Updated" },
  { key: "active", value: "Active" },
  { key: "actions", value: "" },
];
